
import React from 'react';

interface ToolCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  color: string;
  onClick: () => void;
}

const ToolCard: React.FC<ToolCardProps> = ({ title, description, icon, color, onClick }) => {
  return (
    <div 
      className="flex items-center p-4 bg-white rounded-xl shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-all hover:-translate-y-1"
      onClick={onClick}
      style={{background: 'linear-gradient(to right, #ffffff, #fffbeb)'}}
    >
      <div 
        className="flex-shrink-0 mr-4 rounded-full p-3 shadow-md"
        style={{ 
          background: `linear-gradient(135deg, ${color}, ${color}dd)`,
          boxShadow: `0 10px 15px -3px ${color}33, 0 4px 6px -4px ${color}33`
        }}
      >
        {icon}
      </div>
      <div className="flex-1">
        <h3 className="text-xl font-medium text-gray-800">{title}</h3>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
    </div>
  );
};

export default ToolCard;
